// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchComponents_profile-summary__\\+0RbR {
  display: flex;
}
.SearchComponents_profile-summary__\\+0RbR .SearchComponents_profile-img__Uvju3 img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.SearchComponents_profile-summary__\\+0RbR .SearchComponents_profile-info__Ol2FO {
  margin-left: 10px;
  color: #6f6f6f;
}
.SearchComponents_profile-summary__\\+0RbR .SearchComponents_profile-info__Ol2FO .SearchComponents_profile-name__J0Xdj {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Components/SearchComponents/SearchComponents.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AACN;AAEE;EACE,iBAAA;EACA,cAAA;AAAJ;AACI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AACN","sourcesContent":[".profile-summary {\n  display: flex;\n  .profile-img {\n    img {\n      width: 80px;\n      height: 80px;\n      border-radius: 10px;\n      object-fit: cover;\n    }\n  }\n  .profile-info {\n    margin-left: 10px;\n    color: #6f6f6f;\n    .profile-name {\n      color: black;\n      font-weight: 600;\n      font-size: 16px;\n      margin-bottom: 5px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile-summary": `SearchComponents_profile-summary__+0RbR`,
	"profile-img": `SearchComponents_profile-img__Uvju3`,
	"profile-info": `SearchComponents_profile-info__Ol2FO`,
	"profile-name": `SearchComponents_profile-name__J0Xdj`
};
export default ___CSS_LOADER_EXPORT___;
